export const SCHOOL_ROUTE_NAMES = {
  CREATE: "AddSchool",
  EDIT: "EditSchool",
} as const;

export type SchoolRouteName =
  (typeof SCHOOL_ROUTE_NAMES)[keyof typeof SCHOOL_ROUTE_NAMES];
